import axios from './config';

export const getLocation = () => {
  return axios.get(`/address-contacts`).then(res => res.data.data);
};
